<template>
  <div class="protocol loan-instruction-protocol">
    <navigation>借款须知及风险提示</navigation>
    <instruction></instruction>
    <p
      data-sensors-exposure-property-page_status="page_bottom"
      data-sensors-exposure-event-name="general_event"
    >
      &nbsp;<!-- 监听协议滑动到了底部，每个协议都加上-->
    </p>
  </div>
</template>

<script>

export default {
  name: 'loan-instruction-protocol',
  components: {
    instruction: () => import('@/view/protocol/components/monitor-instruction.vue')
  },


  data () {
    return {}
  },
  created () {
    this.$bus.$emit('ready')
  },
  mounted () {},
  methods: {}
}
</script>

<style scoped lang="less">
@import "../../../assets/less/mixin.less";

.loan-instruction-protocol {
  width: 100%;
  position: relative;

  .bolder {
    font-weight: bolder;
  }

  .text {
    text-indent: 40px;
  }

  .text:last-child {
    margin-bottom: 100px;
  }

  .tab-0 {
    text-indent: 0;
  }

  .underline {
    text-indent: 200px;
    font-weight: bold;
    text-decoration: underline;
  }

  .underline:last-child {
    margin-bottom: 100px;
  }
}
</style>
